import React, { useEffect, useState } from 'react';
import CommentThread from '../../../../shared/components/comments/CommentThread';
import {
  createAssignmentCommentResult,
  listAssignmentCommentsResult,
} from '@/modules/deals/services';

export default function AssignmentComments({
  assignment,
  autoFocus = false,
  currentUser,
  staff = [],
  commentsWritable = true,
}) {
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function loadComments() {
      setLoading(true);
      setError('');
      const result = await listAssignmentCommentsResult(assignment.id);
      if (cancelled) return;
      setComments(result.ok ? result.data : []);
      setError(result.ok ? '' : result.message || 'Commenti non disponibili.');
      setLoading(false);
    }

    loadComments();

    return () => {
      cancelled = true;
    };
  }, [assignment.id]);

  async function publishComment(payload) {
    const body = String(payload?.body || '').trim();
    if (!body || submitting || !commentsWritable) return { ok: false };

    setSubmitting(true);
    setError('');
    const result = await createAssignmentCommentResult(assignment.id, body);
    setSubmitting(false);

    if (!result.ok) {
      setError(result.message || 'Commento non salvato.');
      return result;
    }

    setComments((prev) => [...prev, result.data]);
    return result;
  }

  async function publishReply(parentId, payload) {
    const body = String(payload?.body || '').trim();
    if (!body || !parentId || submitting || !commentsWritable) return { ok: false };

    setSubmitting(true);
    setError('');
    const result = await createAssignmentCommentResult(assignment.id, body, parentId);
    setSubmitting(false);

    if (!result.ok) {
      setError(result.message || 'Risposta non salvata.');
      return result;
    }

    setComments((prev) => [...prev, result.data]);
    return result;
  }

  return (
    <div className="mt-4">
      <CommentThread
        autoFocus={autoFocus}
        title="Commenti"
        comments={comments}
        currentUser={currentUser}
        staff={staff}
        isLoading={loading}
        isSubmitting={submitting}
        error={error}
        emptyLabel="Nessun commento ancora"
        placeholder={
          commentsWritable
            ? 'Aggiungi un commento...'
            : 'Commenti non disponibili: manca persistenza backend in questo step.'
        }
        submitLabel="Aggiungi commento"
        onSubmitComment={publishComment}
        onSubmitReply={publishReply}
        allowReplies
        entityType="assignment"
        entityId={assignment.id}
        readOnly={!commentsWritable}
        disabled={!commentsWritable}
      />
    </div>
  );
}
